import { makeStyles } from '@material-ui/core/styles';

import { bgColor, minimWidth, maximWidth, spinnerLoadingColor } from '../utils/constants';

// Palete de colors aqui: https://material-ui.com/customization/palette/

const generalStyles = makeStyles((theme) => ({
  root: {
    minWidth: minimWidth,
    maxWidth: maximWidth,
  },
  content: {
    backgroundColor: bgColor,
    margin: theme.spacing(1),
    flexDirection: 'column',
  },
  body: {
    margin: theme.spacing(1),
  },
  paper: {
    padding: theme.spacing(1),
    textAlign: 'center',
    color: 'red',
  },
  backdropSpinnerLoading: {
    zIndex: theme.zIndex.drawer + 1,
    color: spinnerLoadingColor,
  },
  addMargin: {
    margin: theme.spacing(1),
  },
}));

export default generalStyles;
